angular.module('cian.serp').factory('SerpListService', [
	'$log',
	'$window',
	'$http',
	'$q',
	'$location',
	'$rootScope',
	'$timeout',
	'ApiService',
	'AnalyticsService',
	'OfferService',
	'ScrollService',
	'StatsService',
	'SerpViewMode',
	'FilterSortService',
	'MetaService',
	function ($log, $window, $http, $q, $location, $rootScope, $timeout, ApiService, AnalyticsService, OfferService, ScrollService, StatsService, SerpViewMode, FilterSortService, MetaService) {
		// Структура данных сервиса
		var service = {
			// Изначальный запрос, результаты которого были видны при загрузке страницы
			initialQuery: null,
			/**
			 * Запрос, результаты которого отображаются сейчас
			 * @memberOf SerpListService
			 * @type {object}
			 */
			lastQuery: null,
			// Последний ответ от сервера
			lastGetOffersResult: null,
			// Результаты выдачи
			offers: {
				html: null, // в виде html
				json: null // объектами
			}
		};

		service.lastQuery = service.initialQuery = $window.cianConfig.query;
		var willReload;

		function updateAddressBar(url) {
			$window.history.replaceState({}, document.title, url);
			$location.url(url);
			$location.replace();
		}

		/**
		 * @param {object} query - запрос
		 * @param {number} page - номер страницы
		 * @param {boolean} areSameOffers - true, если не меняется набор результатов
		 * (например, изменилась только страница или сортировка)
		 * @return {Promise}
		 */
		service.updateOffers = function (query, page, areSameOffers) {
			var start = Date.now();

			// Не отправляем page=1, чтобы не портить ЧПУ
			var newQuery = angular.copy(query);
			if (page > 1) {
				newQuery.page = {
					type: 'term',
					value: page > 1 ? page : null,
				};
			} else {
				delete newQuery.page;
			}

			$rootScope.offersLoading = true;
			ScrollService.smoothScrollTo(0);
			ScrollService.disableScroll();

			// Не проверяем редиректы, если переходим по пагинации или меняем сортировку
			if (!areSameOffers) {
				// TODO удалить этот код, после выкатки на все регионы
				// Если в прошлом meta запросе redirectToOldForm === true то обновляем страницу и открывается старая выдача
				if (window.__redirectToOldForm) {
					window.location.href = window.__currentFiltersUrl;
					return;
				}

				// https://jira.cian.tech/browse/CSSSR-5165
				// Если изменился поддомен, перезагружаем страницу, чтобы обновился урл (нужно для SEO)
				// Исключение: если выдача по карте, то не проверяем поддомены
				// (бэк не умеет определять поддомен по карте и возвращает урл без поддомена)
				if (window.__currentFiltersUrl) {
					var geoValues = getVal(newQuery.geo);
					var queryHasMapObjects = geoValues && geoValues.some(function (g) {
							return g.type === 'polygon' || g.type === 'distance'
						});
					if (!queryHasMapObjects) {
						var parser = document.createElement('a');
						parser.href = window.__currentFiltersUrl;
						if (parser.hostname !== window.location.hostname) {
							window.location.href = window.__currentFiltersUrl;
							return;
						}
					}
				}
			}

			// Сортировка
			(function() {
				// "Показать результаты" => обновляем варианты сортировки до запроса к API,
				// т.к. в новом фильтре может не быть выбранной сейчас сортировки
				if (!areSameOffers) {
					FilterSortService.updateItems();
				}

				// Добавляем выбранную сортировку к запросу
				delete newQuery.sort;
				delete newQuery.quality;
				angular.extend(newQuery, FilterSortService.getSortParams());
			})();

			return ApiService.getOffers(newQuery, SerpViewMode.isTable)
				.then(function (data) {
					updateAddressBar(data.url);

					// Если выбран табличный вид, но он не доступен для новой выдачи,
					// то переключаемся на список
					if (data.isTable !== SerpViewMode.isTable) {
						SerpViewMode.setMode('list');
						willReload = true;
						return;
					}

					// Проверяем, изменился ли ЖК
					if (shouldReload(newQuery)) {
						$window.location.reload();
						willReload = true;
						return;
					}

					service.lastQuery = newQuery;
					service.lastGetOffersResult = data;
					$window._offers = data.offersSerialized;
					service.offers = {
						html: data.offersHtml,
						json: data.offersSerialized
					};
					OfferService.updateOffers(service.offers);

					// Определяем, доступен ли табличный вид
					SerpViewMode.setModeAvailability('table', data.isShowModeSwitcher);

					if (!areSameOffers) {
						MetaService.reset(data.url);
					}

					// Чтобы успел обновиться dataLayer
					$timeout(function () {
						AnalyticsService.trackPageView({
							fullUrl: service.getFullUrl(),
							sortType: FilterSortService.sort.value,
							searchConditions: service.lastQuery,
							pageNumber: newQuery.page && newQuery.page.value,
						});
					});
					return data;
				})
				.catch(function (message) {
					Notifications.add({
						type: 'error',
						content: message,
						timeout: 3000
					});
				})
				.finally(function () {
					// Чтобы успела спрятаться шапка ЖК/БЦ и перерисоваться хлебные крошки
					$timeout(function() {
						if (!willReload) { // Не убираем прелоадер, если обновляем страницу
							$rootScope.offersLoading = false;
							ScrollService.enableScroll();
						}

						StatsService.sendMetric('newserp-ajax', 'applicationStart', Date.now() - start);
					});
				});
		};

		service.goToPage = function (page) {
			service.updateOffers(service.lastQuery, page, true);
		};

		/**
		 * Применяем сортировку к той выдаче, которая сейчас отображается
		 * Не учитываем изменённые фильтры
		 */
		service.sortOffers = function () {
			service.updateOffers(service.lastQuery, 1, true);
		};

		function shouldReload(newQuery) {
			return shouldUpdateNewobjectHeader(newQuery) ||
				shouldUpdateBCHeader(newQuery);
		}


		// Методы для шапки ЖК

		service.isInitialNewObjectSelected = function () {
			return angular.isDefined(getNewobjectId(service.initialQuery)) &&
				!isNewobjectDiffers(service.initialQuery, service.lastQuery)
		};

		// Нужно обновить шапку ЖК, если:
		// 1. При загрузке не было ЖК, а теперь выбрали
		// 2. При загрузке был один ЖК, а выбрали другой
		// Если выбрали несколько ЖК, то страницу не обновляем, а шапку прячем
		function shouldUpdateNewobjectHeader(newQuery) {
			return angular.isDefined(getNewobjectId(newQuery)) &&
				isNewobjectDiffers(service.initialQuery, newQuery);
		}

		function getNewobjectId(query) {
			return getOnlyOneOfGeoType(query, 'newobject');
		}

		function isNewobjectDiffers(queryA, queryB) {
			return getNewobjectId(queryA) !== getNewobjectId(queryB)
		}


		// Методы для шапки застройщика

		service.isInitialBuilderSelected = function () {
			return angular.isDefined(getBuilderId(service.initialQuery)) &&
				!isBuilderDiffers(service.initialQuery, service.lastQuery)
		};

		function getBuilderId(query) {
			return getOnlyOneOfGeoType(query, 'builder');
		}

		function isBuilderDiffers(queryA, queryB) {
			return getBuilderId(queryA) !== getBuilderId(queryB)
		}


		// Методы для шапки БЦ

		// Проверяем 2 параметра: bs_center (массив БЦ) и bs_center_id (id одного БЦ)
		service.isInitialBCSelected = function () {
			return (
					angular.isDefined(service.initialQuery.bs_center) ||
					angular.isDefined(service.initialQuery.bs_center_id)
				) && !isBCDiffers(service.initialQuery, service.lastQuery)
		};

		// Логика аналогична шапке ЖК
		function shouldUpdateBCHeader(newQuery) {
			return angular.isDefined(getOnlyBCId(newQuery)) &&
				isBCDiffers(service.initialQuery, newQuery);
		}

		/**
		 * Если выбран 1 БЦ, то возвращает его id
		 * Если выбрано несколько, то undefined
		 * @param query
		 * @return {number?}
		 */
		function getOnlyBCId(query) {
			var BCList = getVal(query.bs_center);
			if (BCList && BCList.length === 1) return BCList[0];
		}

		function isBCDiffers(queryA, queryB) {
			return getOnlyBCId(queryA) !== getOnlyBCId(queryB) ||
				isParamDiffers('bs_center_id', queryA, queryB);
		}


		service.getSearchTitle = function () {
			return service.lastGetOffersResult ?
				service.lastGetOffersResult.h1 :
				$window._h1;
		};

		service.URL_CONTEXTS = {
			MAP: 'map',
			OLD_FILTERS: 'old_filters',
		};

		service.getFullUrl = function (context) {
			var base;
			var postfix = '';
			switch (context) {
				case service.URL_CONTEXTS.MAP:
					base = '//map.cian.ru/?';
					break;
				case service.URL_CONTEXTS.OLD_FILTERS:
					base = '/nd/search/?';
					postfix = '&show_old_form=1';
					break;
				default:
					// Выдача
					base = '/cat.php?';
			}

			return base + (
				service.lastGetOffersResult ?
				service.lastGetOffersResult.gaQuerystring :
				$window._gaQuerystring
			) + postfix;
		};

		/** @memberOf SerpListService */
		service.getOffersCount = function () {
			return service.lastGetOffersResult ?
				service.lastGetOffersResult.offerCount :
				$window._offersCount;
		};

		service.getSimilarOffersCount = function () {
			return service.lastGetOffersResult ?
				service.lastGetOffersResult.similarOffersCount :
				$window._similarOffersCount;
		};

		// Возвращает ссылку для кнопки "Искать в бизнес-центрах"
		service.getBsCenterListUrl = function () {
			return service.lastGetOffersResult ?
				service.lastGetOffersResult.bsCenterListUrl :
				$window._bsCenterListUrl;
		};


		// Utilities

		// Возвращает id гео-объекта, если он единственный в гео
		// Нужно для ЖК и застройщиков, т.к. наличие другого гео (например, метро) может расширять выдачу и в таком случае нельзя показывать шапку ЖК/застройщика
		function getOnlyOneOfGeoType(query, type) {
			if (
				query.geo &&
				angular.isArray(query.geo.value) &&
				query.geo.value.length === 1 &&
				query.geo.value[0].type === type
			) return query.geo.value[0].id;
		}

		// Сравнивает параметр в двух разных наборах фильтров
		function isParamDiffers(paramName, queryA, queryB) {
			return !angular.equals(
				getVal(queryA[paramName]),
				getVal(queryB[paramName])
			);
		}

		/**
		 * Возвращает значение параметра из фильтра
		 * @param {object} filterParam
		 * @return {*} Если параметра нет, то возвращает undefined
		 */
		function getVal(filterParam) {
			if (filterParam) return filterParam.value;
		}


		return service;
	}
]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.listService.js
// module id = 491
// module chunks = 0